export const FEATURED_SANDBOXES_ALBUM = 'i1pxky';
export const TRENDING_SANDBOXES_ALBUM = 'nynbnp';

export const banner = {
  label: 'NEW FEATURE',
  title: 'Welcome Discover Page',
  subtitle: 'Search sandboxes from the community right on your dashboard',
  image: '/static/img/discover-banner-search.png',
  link: 'https://codesandbox.io/post/discover-announcement',
};
